import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import lang from "i18next";

class WidgetCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
    };
  }

  static getDerivedStateFromProps(props) {
    return {
      id: props.id,
    };
  }

  renderExpiry(item) {
    if (item.data.cardExpiry !== undefined) {
      return (
        <div className="info">
          <label>{lang.t("widgets:form.card.expires")}</label>
          <p>{item.data.cardExpiry}</p>
        </div>
      );
    }
  }

  render() {
    var data = null;
    for (var item of global.clients) {
      if (item.id === this.state.id) {
        debugger;
        data = item;
      }
    }
    if (data !== null) {
      return (
        <div className="card-info">
          <div className={"logo mb-30 " + data.data.cardBrand}></div>
          <div className="info clear mb-20">
            <label>{lang.t("widgets:form.card.number")}</label>
            <p>**** **** **** {data.data.cardLast4}</p>
          </div>
          {this.renderExpiry(data)}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default withTranslation(["widgets"])(WidgetCard);
